module.exports = __webpack_public_path__ + "assets/7e526cb204567c97543d05aae275dc43.jpg";